import { Page } from "@/models/page-models/Page";

export const CustomerSalesForecast: Page = {
  "path": "customer-sales-forecast",
  "name": "Customer Forecast",
  "props": {
    "data": {
      "title": "Customer Forecast",
      "printable": "FALSE",
      "url": "customer-sales-forecast",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesForecastForm.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2024,2025,2026,2027]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesForecastForm.customer",
                  "label": "Select Customer",
                  "disabled": "fn(NOT,{{fetchedData.salesForecastForm.year}})",
                  "items": "fetchedData.customer.data",
                  "itemText": "alias",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetForecastData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.currentSalesForecast"
                      },
                      "name": "resetForecastData"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.salesForecastForm.displaySAR",
                  "label": "Data Type",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"Quantity\",\"value\":false},{\"text\":\"SAR\",\"value\":true}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetForecastData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.currentSalesForecast"
                      },
                      "name": "resetForecastData"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Customer Forecast",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToSalesForecast",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/customer-sales-forecast",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{fetchedData.salesForecastForm.customer}}\",\"year\":\"{{fetchedData.salesForecastForm.year}}\",\"displaySAR\":\"{{fetchedData.salesForecastForm.displaySAR}}\"}"
                      },
                      "name": "redirectToSalesForecast"
                    }
                  ],
                  "disabled": "fn(NOT,{{fetchedData.salesForecastForm.customer}})",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "salesForecast",
                  "showIf": "{{fetchedData.currentSalesForecast.data}}",
                  "disabled": "fn(NOT,{{fetchedData.salesForecastFlag.status}})",
                  "projectedItemsVariable": "formData.projectedItems",
                  "forecastDataVariable": "fetchedData.currentSalesForecast.data",
                  "productsVariable": "fetchedData.products.data.docs",
                  "displaySarVariable": "fetchedData.salesForecastForm.displaySAR"
                }
              ],
              "showIf": "{{fetchedData.currentSalesForecast.data}}",
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.currentSalesForecast.data.status}},'),==,'Approved')"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Status",
                  "variable": "fetchedData.currentSalesForecast.data.status",
                  "showIf": "{{fetchedData.currentSalesForecast.data}}",
                },
                {
                  "type": "label",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.currentSalesForecast.data.updatedAt}})",
                  "showIf": "{{fetchedData.currentSalesForecast.data}}",
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save As Draft",
                  "disabled": "fn(NOT,{{fetchedData.salesForecastFlag.status}})",
                  "showIf": "fn(LENGTH,{{formData.projectedItems}})",
                  "color": "primary",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDraftFlag",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDraftFlag",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "copyDraftFlag"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "saveDraftForecast",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-forecast/{{fetchedData.currentSalesForecast.data._id}}/submit",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "saveDraftForecast"
                    }
                  ]
                },
                {
                  "type": "button",
                  "label": "Submit",
                  "disabled": "fn(NOT,{{fetchedData.salesForecastFlag.status}})",
                  "showIf": "fn(LENGTH,{{formData.projectedItems}})",
                  "color": "secondary",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "submitForecast",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-forecast/{{fetchedData.currentSalesForecast.data._id}}/submit",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "submitForecast"
                    }
                  ]
                }
              ],
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.currentSalesForecast.data.status}},'),==,'Approved')",
              "showIf": "fn(LOGICAL,fn(LOGICAL,{{fetchedData.salesForecastForm.customer}},>,0),&&,fn(NOT,{{fetchedData.salesForecastForm.displaySAR}}))"
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.currentSalesForecast.data.status}},'),==,'Submitted')",
                  "color": "secondary",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveForecast",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-forecast/{{fetchedData.currentSalesForecast.data._id}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "approveForecast"
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,{{fetchedData.salesForecastForm.displaySAR}})"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Cancel",
                  "disabled": "{{fetchedData.selectedCustomer.active}}",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.currentSalesForecast.data.status}},'),==,'Draft')",
                  "color": "error",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "cancelForecast",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-forecast/{{fetchedData.currentSalesForecast.data._id}}/cancel",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "cancelForecast"
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,{{fetchedData.salesForecastForm.displaySAR}})"
            }
          ],
          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
          "disabled": "fn(NOT,{{fetchedData.salesForecastFlag.status}})",
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true,
      "pageComments": {
        "commentsVariable": "fetchedData.currentSalesForecast.data.comments",
        "newCommentVariable": "fetchedData.commentsForm.text",
        "addComentAction": [
          {
            "executionOrder": 1,
            "name": "copyDefaultModel",
            "pageFunction": {
              "name": "copyDefaultModel",
              "type": "fnCopyData",
              "arg1Key": "sourceFn",
              "arg1Value": "getDefaultModel",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentsForm"
            }
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "addComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/sales-forecast/{{fetchedData.currentSalesForecast.data._id}}/add",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.commentsForm",
              "arg3Key": "refreshPage",
              "arg3Value": "TRUE"
            },
            "name": "addComment"
          }
        ],
        "deleteCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "deleteComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/delete?model=salesForecast",
              "arg2Key": "postData",
              "arg2Value": "{}",
              "arg3Key": "requestMethod",
              "arg3Value": "DELETE",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "deleteComment"
          }
        ],
        "updateCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "copyEditCommentTextForm",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item",
              "arg2Key": "sourceFn",
              "arg2Value": "getEditCommentTextForm",
              "arg3Key": "destinationKey",
              "arg3Value": "fetchedData.editedCommentForm"
            },
            "name": "copyEditCommentTextForm"
          },
          {
            "executionOrder": 3,
            "pageFunction": {
              "name": "updateComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/edit",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.editedCommentForm",
              "arg3Key": "requestMethod",
              "arg3Value": "PATCH",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "updateComment"
          }
        ]
      }
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultSalesforecastForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultSalesforecastForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.salesForecastForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "getDefaultSalesforecastForm"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copySalesforecastFlag",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getSalesforecastFlag",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.salesForecastFlag",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copySalesforecastFlag"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductsForm",
        "executeIf": "fn(LOGICAL,{{fetchedData.salesForecastForm.customer}},>,0)"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToProductForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.salesForecastForm.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.productForm.q.customer"
        },
        "name": "pushCustomerIdToProductForm",
        "executeIf": "fn(LOGICAL,{{fetchedData.salesForecastForm.customer}},>,0)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProducts",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/product/search",
          "arg2Key": "postData",
          "arg2Value": "fetchedData.productForm",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.products"
        },
        "name": "getProducts",
        "executeIf": "fn(LOGICAL,{{fetchedData.salesForecastForm.customer}},>,0)"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "loadSalesForecastData",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sales-forecast/generate",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.currentSalesForecast",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.salesForecastForm"
        },
        "name": "loadSalesForecastData",
        "executeIf": "fn(LOGICAL,{{fetchedData.salesForecastForm.customer}},>,0)"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "copyCustomerData",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getCustomerData",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.selectedCustomer"
        },
        "name": "copyCustomerData"
      }
    ],
    "functions": [
      {
        "name": "getDefaultSalesforecastForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "customer": "fn(NUMBER,{{__query.customer}})",
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{FORECAST_YEAR}})",
          "displaySAR": "fn(CONDITIONAL,{{__query.displaySAR}},{{__query.displaySAR}},false)"
        },
        "useFormula": true
      },
      {
        "name": "getSalesforecastFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "status": "fn(FEATURE_FLAG,Sales Forecast)"
        },
        "useFormula": true
      },
      {
        "name": "getDraftFlag",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "isDraft": true
        },
        "staticObject": true
      },
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": [
              "Open", "Closed"
            ]
          },
          "page": 1
        },
        "staticObject": true
      },
      {
        "name": "getCustomerData",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.customer.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.salesForecastForm.customer"
      },
      {
        "name": "getDefaultModel",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "model": "salesForecast",
          "text": "{{fetchedData.commentsForm.text}}"
        },
        "useFormula": true
      },
      {
        "name": "getEditCommentTextForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "text": "__item.text",
          "model": "__item.targetModel"
        }
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 70
}